module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBold.4fca077.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sourceSansPro/SourceSansPro-SemiBold.woff
// module id = ideR
// module chunks = 88